import React from "react";
import { Button, Menu, Modal } from "semantic-ui-react";
import WikiAdvocateList from "./WikiAdvocateList";

const WikiAdModal = (props) => {
  return (
    <Modal
      size="tiny"
      onClose={() => props.setOpen(false)}
      onOpen={() => props.setOpen(true)}
      open={props.open}
    >
      <Modal.Content scrolling className="eventVisitorModal">
        <div className="eventVisitorModalButton">
          <Button
            floated="left"
            circular
            icon="close"
            onClick={() => props.setOpen(false)}
          />

          <Button icon circular color="blue" onClick={() => {}}>
            {props.wiki.advocates.length < 10 ? "0" : ""}
            {props.wiki.advocates && props.wiki.advocates.length}
          </Button>
        </div>

        <div className="list">
          <Menu className="cu-tab" pointing secondary>
            <Menu.Item
              name="Advocates"
              active
              className="inner-link"
              onClick={() => {}}
            />
          </Menu>
          <WikiAdvocateList advocates={props.wiki.advocates} />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default WikiAdModal;
